import clientController from "../../../controllers/clientController/controller";
import Swal from 'sweetalert2';
import { EventBus } from '@/eventBus';
import config from "../../../../config";

export default {
    name: 'SimpleTable',
    data(){
        return {
            company: '',
            clientList: [],
            currentPage: 1,
            apiUrl: config.AWS_URL + 'gambar/client/',
            pageSize: 10,
            totalPages: 0,
            totalClients: 0,
            gambarName: 'Pilih Gambar',
            gambarUrl: '',
            searchQuery: '',
            client: {
                id:'',
                gambar: '',
                created_by: '',
                created_by_name: '',
                created_on: '',
                status: ''
            },
            selectedClient:{
                updated_by: '',
                updated_by_name: '',
            }
        }
    },
    computed: {
        filteredClients() {
            return this.clientList.filter(client => client.gambar.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
        pages(){
            return Math.ceil(this.totalClients / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
    
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
            if (start === 1) {
                end = Math.min(3, this.pages);
            } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
            }
            }
    
            const pages = [];
            for (let i = start; i <= end; i++) {
            pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods: {
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.client.created_by = id;
            this.selectedClient.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.client.created_by_name = name;
            this.selectedClient.updated_by_name = name;
        },
        showModal(type, id) {
            this.user();
            const client = this.clientList.find(client => client.id === id);
            if (client) {
                this.client = client;
                
                const modal = document.getElementById(type === 'edit' ? 'editClient' : 'detailClient');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
          const modalIds = ['tambahClient', 'editClient', 'detailClient'];
          modalIds.forEach(id => {
            const modal = document.getElementById(id);
            if (modal && modal.classList.contains('show')) {
              modal.classList.remove('show');
              setTimeout(() => {
                modal.style.display = 'none';
              }, 300);
            }
          });
        
          // Hapus backdrop
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(backdrop => {
            backdrop.classList.remove('show');
            setTimeout(() => {
              if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
              }
            }, 300);
          });
        
          // Hapus kelas atau atribut yang mengunci scroll pada body
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.overflow = ''; // Menghapus properti overflow jika ada
          this.getClient();
          this.resetForm();
        },    
        resetForm() {
            this.gambarName = 'Pilih Gambar';
            this.gambarUrl = '';
            this.client.gambar = '';
            this.client.status = '';
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.getClient();
            }
        },
        async handleFileUpload(event) {
            try{
                const file = event.target.files[0];
                if (file) {
                    this.gambarName = file.name;
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.gambarUrl = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
                if (!file) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Silahkan pilih file',
                        timer: 1500
                    })
                    return;
                }
    
                // Validasi tipe file (opsional)
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
                if (!allowedTypes.includes(file.type)) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Format file tidak sesuai',
                        timer: 1500
                    })
                    return;
                }
                const allowedSize = 1 * 1024 * 1024; // 1 MB
                if (file.size > allowedSize) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops..',
                        text: `Ukuran file terlalu besar, maksimal ${allowedSize / 1024 / 1024} MB`,
                        timer: 1500
                    })
                    this.resetForm();
                    return;
                }
    
                this.client.gambar = file;
            } catch (error) {
                console.error('Error uploading file:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal mengunggah file',
                })
            }
        },
        async getClient() {
            try{
                const company_id = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await clientController.getClient(query, this.currentPage, this.pageSize, company_id);
                this.clientList = response.data;
                this.totalAllClients();
            } catch (error) {
                console.error('Error fetching clients:', error);
            }
        },
        async totalAllClients(search) {
            try {
                const company_id = this.company;
                const sanitizedSearch = search && search.trim() !== '' ? search : null;
                const response = await clientController.totalAllClients(sanitizedSearch, company_id);
                this.totalClients = response;
            } catch (error){
                console.error('Error fetching clients:', error);
            }
        },
        async addClient() {
            try {
                Swal.fire({
                    title: 'Loading...',
                    text: 'Please wait while the client is being added',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        Swal.showLoading();
                    }
                });

                const formData = new FormData();
                const now = new Date();
                this.client.created_on = now.toISOString().slice(0, 19).replace('T', ' ');
                formData.append('client', this.client.gambar);
                formData.append('created_by', this.client.created_by);
                formData.append('created_by_name', this.client.created_by_name);
                formData.append('created_on', this.client.created_on);
                formData.append('id_company', this.company);
                formData.append('is_active', this.client.status);

                const response = await clientController.addClient(formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                Swal.close();

                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Client berhasil ditambahkan',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.closeModal();
                    this.getClient();
                    this.resetForm();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Client gagal ditambahkan',
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            } catch (error) {
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: 'Client gagal ditambahkan',
                    showConfirmButton: false,
                    timer: 1500
                });
                console.error('Gagal menambahkan :', error);
            }
        },
        async updateClient(){
            try{
                const id = this.client.id;
                const status = this.client.status;
                const updated_by = this.selectedClient.updated_by;
                const updated_by_name = this.selectedClient.updated_by_name;
                const now = new Date()
                const updated_on = now.toISOString().slice(0,19).replace('T', ' ');   
                if (!id || !status || !updated_by || !updated_by_name) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal memperbaharui data',
                    text: 'Isi semua field!!',
                    timer: 1500
                })
                }  
                const update = {
                    id: id,
                    is_active: status,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name,
                    updated_on: updated_on
                };
                const response = await clientController.updateClient(update);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Client berhasil diperbaharui',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.closeModal();
                    this.getClient();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Client gagal diperbaharui',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.closeModal();
                    this.getClient();
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Client gagal diperbaharui',
                    showConfirmButton: false,
                    timer: 1500
                });
            }
        },
        async deleteClient(id, gambar) {
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try {
                    Swal.fire({
                        title: 'Loading...',
                        text: 'Please wait while the client is being deleted',
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        willOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    const response = await clientController.deleteClient(id, gambar);
                    if (response.status === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Client berhasil dihapus',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Client gagal dihapus',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    }
                    this.getClient();
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Client gagal dihapus',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        }
    },
    mounted(){
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
    },
    beforeDestroy() {
        EventBus.$off("companyChanged", this.onCompanyChange);
    },
    watch: {
        searchQuery: {
            handler: 'getClient',
        },
        company: {
            handler: 'getClient'
        }
    },
}